import { render, staticRenderFns } from "./RedirectUrl.vue?vue&type=template&id=679d3ad8&scoped=true"
import script from "./RedirectUrl.vue?vue&type=script&lang=js"
export * from "./RedirectUrl.vue?vue&type=script&lang=js"
import style0 from "./RedirectUrl.vue?vue&type=style&index=0&id=679d3ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d3ad8",
  null
  
)

export default component.exports